import { createAction } from '@reduxjs/toolkit';
import { UpdateSubscriptionParams } from '../../types/apiType';

export const subscriptionActions = {
  getPriceList: createAction('subscription/GET_PRICE_LIST'),
  getCurrentSubscription: createAction('subscription/GET_CURRENT_SUBSCRIPTION'),
  updateSubscription: createAction<UpdateSubscriptionParams>('subscription/UPDATE_CURRENT_SUBSCRIPTION'),
};
